module.exports = __webpack_public_path__ + "img/bg-bottom-tree.ea9263a0.png";